import React,{ useState, useEffect } from 'react';

import {Input} from '../../kit-components/Input'
import {Button} from '../../kit-components/Button';
import { InfoList} from '../../kit-components/InfoList';
import { PlansRadio} from '../../kit-components/Radio/Plans';

import Skeleton from 'react-loading-skeleton';
import styles from './plans-step.module.scss';


export function PlansStep(props) {
  const { loading,plans,amount, downPayment, handleDownPaymentChange, chosenInstallment, handleInstallmentChange,goToconfirmInstallment } = props;

  const [currency, setCurrency]   = useState("EG");
  const [firstRender, setFirstRender] = useState(true);

  const [agreePay, setAgreePay] = useState(false);
  const [downPaymentAmount, setDownPaymentAmount] = useState(0);


  useEffect(()=>{
  console.log(props.plans);
  },[props.plans]);
  const handleChange = (data) => {
    handleInstallmentChange(data);
  };

  const handleSubmit = () => {
    goToconfirmInstallment();
  };
  const handleDownPaymentAmountChange = (_downPaymentAmount)=>{
    console.log('amountChanged');
    setDownPaymentAmount(_downPaymentAmount);
  }

  useEffect(()=>{
    if(!firstRender){
      
    }
    const delayDebounceFn = setTimeout(() => {
      if(!firstRender){
        handleDownPaymentChange(downPaymentAmount);      
      }
    }, 3000)
    setFirstRender(false);
    return () => clearTimeout(delayDebounceFn);
  },[downPaymentAmount]);

  const validateForm = ()=>{
    if (downPaymentAmount>0 && agreePay !== true){
      return false;
    }
    else{
      return true
    }
  }
  return (
    <div>
      <div className={styles['form']}>
        <Input
          name="downPayment"
          placeholder={currency}
          label="Down payment"
          value={downPaymentAmount}
          onChange={(e)=>handleDownPaymentAmountChange(e.target.value)}
        />

        {(plans && plans.length === 0) ? (
          <div className={styles['plans-skelton']}>
            {[...Array(4).keys()].map((item) => {
              return (
                <div className={styles['item']}>
                  <Skeleton height={65} />
                </div>
              );
            })}
          </div>
        ) : (
          <PlansRadio
            plans={plans}
            onChange={handleChange}
          />
        )}

   {    <InfoList
          title="Payment summary"
          list={[
            {
              key: 'Financed amount',
              value:amount - downPayment
            },
            {
              key: 'Admin Fees',
              value: chosenInstallment.adminFees,
            },
          ]}
        />}

        {downPayment != '0' && (
          <div className={styles['agreement-check']}>
            <input
              name={'agree'}
              type={'checkbox'}
              checked={agreePay}
              onChange={(e) => setAgreePay(e.target.checked)}
            />
            <p className={styles['text']} onClick={()=>{setAgreePay(!agreePay)}}>
              I agree to pay EGP {parseInt(downPayment)+parseInt(chosenInstallment.adminFees)} in cash upon delivery
            </p>
          </div>
        )}

        <div className={styles['actions']}>
          <Button
             disabled={!validateForm()}
            loading={loading}
            label="continue"
            onClick={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
}
